import React from 'react'

function about() {
  return (

    <>
      <title>About Us - Laundry Mart</title>
      <meta name="description" content="Learn about Laundry Mart, a smart laundry and dry cleaning service in Faridabad. From our humble beginnings as Hari Om Drycleaners to our tech-enabled platform, discover our journey, values, and commitment to quality service." />
      <meta name="keywords" content="Laundry Mart, about us, laundry service, dry cleaning, Faridabad, smart laundry, eco-friendly laundry, doorstep pickup, laundry care" />

      <section className="about-us">
        <div className="container">
          <h1>About Us</h1>

          <p>
            Welcome to <strong>Laundry Mart</strong> — where tradition meets technology to bring you smarter, cleaner living. Our journey began in <strong>2006</strong> as <strong>Hari Om Drycleaners</strong>, a humble local laundry service rooted in values of trust, dedication, and attention to detail. From washing everyday clothes to handling delicate fabrics, we have always put quality and customer satisfaction first.
          </p>

          <p>
            Over the years, we witnessed changing lifestyles, busier schedules, and an increasing demand for convenience. This inspired us to evolve. Today, <strong>Laundry Mart</strong> is a smart, tech-enabled laundry and dry cleaning platform, offering <strong>doorstep pickup and delivery</strong> across Faridabad. With just a few taps on your phone, you can schedule a laundry service and leave the rest to us.
          </p>

          <p>
            We offer a comprehensive range of services including regular laundry, dry cleaning, steam ironing, stain removal, and even <em>rafu</em> (darning). Whether it's your daily wear, office formals, party wear, or delicate ethnic clothing, our experts ensure that each garment receives personalized attention and premium care.
          </p>

          <p>
            At Laundry Mart, we blend traditional know-how with modern equipment, ensuring garments are treated gently yet effectively. We also take pride in using <strong>eco-friendly detergents and processes</strong> that not only protect your clothes but also reduce our environmental footprint.
          </p>

          <p>
            Our mission is simple yet impactful: <em>to make laundry care effortless, reliable, and accessible for every household</em>. With an easy-to-use booking system, multiple time slots, regular updates, and timely delivery, we aim to make laundry the easiest part of your routine.
          </p>

          <p>
            Behind every successful delivery is a hardworking team committed to excellence. From our customer service reps to our laundry specialists and delivery staff — every individual at Laundry Mart is driven by a shared goal: delivering fresh, clean clothes and an unmatched customer experience.
          </p>

          <p>
            We thank all our customers for being part of our journey — from the early days of offline service as Hari Om Drycleaners to our transformation into a full-fledged digital laundry brand. Your continued trust and feedback keep us growing and improving every day.
          </p>

          <p><strong>Your clothes. Our responsibility. Delivered with care, precision, and pride.</strong></p>
        </div>



      </section>

    </>


  )
}

export default about